import { useTranslation } from 'react-i18next';
import { Paperclip } from 'lucide-react';
import { StatusChip } from '@/components/ui/Chip';

/**
 * C15 (BIN01-M 4.1/4.5): attachment marker for a MedCom referral — how many
 * attachments the message announces and how many MEDBINs have arrived.
 */
export function AttachmentStatusBadge({ total, received }: { total: number; received: number }) {
  const { t } = useTranslation();
  if (total <= 0) return null;
  const complete = received >= total;
  return (
    <span data-testid="referral-attachment-status">
      <StatusChip tone={complete ? 'completed' : 'draft'}>
        <Paperclip className="h-3 w-3" />
        {complete
          ? t('referrals.attachments_status_complete', { count: total })
          : t('referrals.attachments_status_partial', { received, total })}
      </StatusChip>
    </span>
  );
}
